// استایل مشترک react-select هماهنگ با رنگ برند و فرم‌های پروژه.
// menuPortalTarget={document.body} همراه با menuPosition="fixed" باید در هر
// استفاده تنظیم شود تا منو زیر مودال‌ها پنهان نشود.
export const selectStyles = {
  control: (base: any, state: any) => ({
    ...base,
    minHeight: "42px",
    borderRadius: "0.375rem",
    borderColor: state.isFocused ? "#C0151B" : "#e2e8f0",
    boxShadow: "none",
    "&:hover": { borderColor: "#C0151B" },
  }),
  menu: (base: any) => ({ ...base, zIndex: 9999 }),
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  option: (base: any, state: any) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#C0151B"
      : state.isFocused
        ? "#fef3f3"
        : "transparent",
    color: state.isSelected ? "#fff" : "#1f2937",
  }),
};

export default selectStyles;
